import React from 'react';

export default function Track({ source, target, getTrackProps, disabled }) { // your own track component
    return (
      <div
        style={{
          position: 'absolute',
          height: 3,
          zIndex: 1,
          marginTop: 25,
          backgroundColor: disabled?'#B6B9BF':'#546C91',
          borderRadius: 1,
          cursor: 'pointer',
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()} // this will set up events if you want it to be clickeable (optional)
      />
    )
  }